import GatsbyImage from "gatsby-image";
import { get, has } from "lodash";
import React, { useRef, useState } from "react";
import Footer from "../components/Layout/Footer";
import Navbar from "../components/Layout/Navbar";
import TopBar from "../components/Layout/TopBar";
// import SEO from "../components/seo"
import SEO from "../components/seo";
import { css } from "@emotion/core";
import tw from "tailwind.macro";
import QuoteMark from "../images/quote-mark.png";
import useIntersectionObserver from "../loaders/useIntersectionObserver";
import shuffle from "lodash/shuffle";
import { FaFacebookF, FaTwitter } from "react-icons/fa";
import { AnimatePresence, AnimateSharedLayout, motion } from "framer-motion";
import ReusableTiles from "../components/ReusableTiles";
import SecondReusableTiles from "../components/SecondReusableTiles";
import FeedingGreatness2024 from "../components/FeedingGreatness2024";
import ParallaxEverydayHero from "../components/ParallaxEverydayHero";
import DogStory from "../components/DogStory";
import DesktopMenu from "../components/Layout/Navigation/DesktopMenu";
import Navigation from "../components/Layout/Navigation";
import MenuControls from "../components/Layout/Navigation/MenuControls";
import MobileNavigation from "../components/Layout/Navigation/MobileNavigation";
import { graphql, Link } from "gatsby";
import ShareYourStoryButton from "../components/ShareYourStoryButton";
import { InView } from "react-intersection-observer";
export default function Story({ data, location }) {
  const filterTypes = get(location, "state.filterType");
  const filter = get(location, "state.filter");
  const list = React.useMemo(
    () =>
      shuffle(
        data.stories.nodes.filter((story) => {
          if (!filterTypes) {
            return true;
          }

          if (typeof story.frontmatter[filterTypes] == "string") {
            return (
              story.frontmatter[filterTypes] &&
              story.frontmatter[filterTypes] === filter
            );
          } else if (typeof story.frontmatter[filterTypes] == "number") {
            return (
              has(story, "frontmatter.year") && story.frontmatter.year > 2019
            );
          } else if (typeof story.frontmatter[filterTypes] == "object") {
            return (
              story.frontmatter[filterTypes] &&
              story.frontmatter[filterTypes].includes(filter)
            );
          } else {
            return true;
          }
        })
      ),
    [filterTypes, filter]
  );

  const [show, setShow] = useState(5);
  const [cta, setCta] = useState(false);

  const showCta = () => {
    setCta(true);
    // if (typeof window !== "undefined" && window.pageYOffset > 500) {
    //   setCta(true);
    // }
  };
  const hideCta = () => {
    setCta(false);
  };

  return (
    <>
    {/* <SEO title="Dog story" keywords={[`great`, `british`, `dogs`]} /> */}
    <SEO
      title="greatbritishdogs.co.uk | Dog story"
      keywords={[`great`, `british`, `dogs`]}
    />
      <TopBar></TopBar>{" "}
      <Navigation>
        <MenuControls />
        <MobileNavigation></MobileNavigation>
      </Navigation>
      <DesktopMenu />
      <AnimateSharedLayout>
        {" "}
        <motion.div layout>
          <AnimatePresence initial={false}>
            <DogStory story={data.story}></DogStory>

            {list &&
              list.slice(0, show).map((node, index) => (
                <React.Fragment key={index}>
                  {/* every 8 stories show this */}
                  {/* {(index + 1) % 8 == 0 && (
                    <motion.div
                      layout
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 1 }}
                      className="bg-pale-100"
                    >
                      <ReusableTiles />{" "}
                    </motion.div>
                  )} */}

                  {/* First show after 2 stories then after every 12 stories*/}
                  {(index - 1) % 12 == 0 && (
                    <motion.div
                      layout
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 1 }}
                    >
                      <Trigger onIntersect={hideCta} onLeave={showCta} />
                      <FeedingGreatness2024 />
                    </motion.div>
                  )}
                  {/* First show after 5 stories then after every 6 stories*/}
                  {(index - 4) % 6 == 0 && (
                    <motion.div
                      layout
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 1 }}
                      className="bg-pale-100"
                    >
                      <Trigger onIntersect={hideCta} onLeave={showCta} />
                      <ReusableTiles />
                    </motion.div>
                  )}
                  {/* First show after 8 stories then after every 12 stories*/}
                  {(index - 7) % 12 == 0 && (
                    <motion.div
                      layout
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 1 }}
                    >
                      <Trigger onIntersect={hideCta} onLeave={showCta} />
                      <FeedingGreatness2024 />
                    </motion.div>
                  )}

                  <DogStory key={node.frontmatter.slug} story={node} />
                </React.Fragment>
              ))}
          </AnimatePresence>
        </motion.div>
      </AnimateSharedLayout>
      <ShareYourStoryButton show={cta} />
      <Trigger onIntersect={hideCta} onLeave={showCta} />
      <InView
        rootMargin="300px 0px 300px 0px"
        as="div"
        onChange={(inView, entry) => {
          if (inView) {
            setShow(show + 5);
          }
        }}
      ></InView>
      <Footer></Footer>
    </>
  );
}

const Trigger = ({ onIntersect, onLeave }) => {
  const ref = useRef();
  useIntersectionObserver({
    target: ref,
    rootMargin: "100px 0px 100px 0px",
    threshold: 0,
    onIntersect,
    onLeave,
  });

  return <div ref={ref}></div>;
};
const End = ({ onIntersect, onLeave }) => {
  const ref = useRef();
  useIntersectionObserver({
    target: ref,
    rootMargin: "100px 0px 300px 0px",
    threshold: 0,
    onIntersect,
    onLeave,
  });

  return <div className="h-4" ref={ref}></div>;
};

export const query = graphql`
  query Story($slug: ID) {
    stories: allMarkdownRemark(
      filter: {
        fileAbsolutePath: { regex: "/src/storys/" }
        frontmatter: { slug: { ne: $slug } }
      }
    ) {
      nodes {
        frontmatter {
          title
          tags
          slug
          dom
          doy
          location
          year
          video
          thumb {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        html
      }
    }
    story: markdownRemark(frontmatter: { slug: { eq: $slug } }) {
      frontmatter {
        title
        tags
        dom
        doy
        slug
        location
        year
        video
        thumb {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
      html
    }
  }
`;
